import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class templateStore {
    // Properties

    @observable fontFamilies = [
        { value: 'LeMondeSansRegular', label: 'Le Monde Sans Regular' },
        { value: 'PlayfairRegular', label: 'Playfair Regular' },
        { value: 'OpenSansRegular', label: 'Open Sans' },
        { value: 'FsLolaBold', label: 'Fs Lola Bold' },
        { value: 'RalewayRegular', label: 'Raleway Regular' },
        { value: 'WhitneyHtfLight', label: 'Whitney Htf Light' },
        { value: 'GeorgiaRegular', label: 'Georgia Regular' },
        { value: 'AlexandriaFLF', label: 'Alexandria FLF' },
        { value: 'Arial', label: 'Arial' }
    ];

    @observable templates = [];
    @observable template = null;
    @observable activeTemplate = null;
    @observable showUpdateTemplateModal = false;
    @observable itemSearchValue = '';
    @observable manageTemplateTitle = '';
    @observable updateLoading = false;

    // Initialization

    @action initTemplate() {
        this.setShowUpdateTemplateModal(false);

        return ApiCaller.Template.apiGetTemplates().then(resp => {
            if (!resp.isError) {
                this.templates = resp.data;
            } else {
                this.templates = [];
            }

            this.updateLoading = false;
        });
    }

    @action initCreate() {
        this.manageTemplateTitle = 'Add Template';
        this.showUpdateTemplateModal = true;

        this.template = {
            'id': 0,
            'name': '',
            'isSelected': false,
            'setting': '',
            'templateSetting': {
                'theme': 1,
                'menu': {
                    'column': 4,
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 12,
                    'color': '#3D3935',
                    'marginTop': 36,
                    'marginBottom': 4
                },
                'homeHeader': {
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 20,
                    'color': '#FFFFFF'
                },
                'homeInfo': {
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 14,
                    'color': '#FFFFFF'
                },
                'header': {
                    'backgroundColor': '#C3A56B',
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 16,
                    'color': '#FFFFFF'
                },
                'buttonItem': {
                    'borderColor': '#D9D9D9',
                    'backgroundColor': '#FFFFFF',
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 14,
                    'color': '#3D3935'
                },
                'buttonItemSelected': {
                    'borderColor': '#C3A56B',
                    'backgroundColor': '#FFFFFF',
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 14,
                    'color': '#C3A56B'
                },
                'buttonFooter': {
                    'backgroundColor': '#C3A56B',
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 16,
                    'color': '#FFFFFF'
                },
                'footer': {
                    'backgroundColor': '#C3A56B',
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 16,
                    'color': '#FFFFFF'
                },
                'tab': {
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 14,
                    'color': '#3D3935'
                },
                'tabSelected': {
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 14,
                    'color': '#C3A56B'
                },
                'label': {
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 14,
                    'color': '#3D3935'
                },
                'text': {
                    'fontFamily': 'OpenSansRegular',
                    'fontSize': 12,
                    'color': '#3D3935'
                }
            }
        };
    }

    @action initUpdate(id) {
        this.manageTemplateTitle = 'Update Template';
        this.showUpdateTemplateModal = true;

        return ApiCaller.Template.GetById(id).then(resp => {
            if (!resp.isError) {
                this.template = resp.data;
            }
        });
    }

    @action getActive() {
        return ApiCaller.Template.apiGetActive().then(resp => {
            this.activeTemplate = resp;
        });
    }

    // Transaction

    @action createTemplate() {
        this.updateLoading = true;
        return ApiCaller.Template.apiCreateTemplate(this.template);
    }

    @action updateTemplate() {
        this.updateLoading = true;
        return ApiCaller.Template.apiUpdateTemplate(this.template.id, this.template);
    }

    @action deleteTemplate(id) {
        return ApiCaller.Template.Delete(id);
    }

    @action activateTemplate(id) {
        return ApiCaller.Template.GetById(id).then(resp => {
            if (!resp.isError) {
                let data = resp.data;
                data.isSelected = true;
                return ApiCaller.Template.apiUpdateTemplate(data.id, data);
            }
        });
    }

    @action getByModuleName(moduleName) {
        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.Template.GetByModuleNameAndLanguageCode(moduleName, languageCode);
    }

    @action setShowUpdateTemplateModal(value) {
        this.showUpdateTemplateModal = value;
    }

    @action setmoduleName(value) {
        if (this.template) {
            this.template.moduleName = value;
        }
    }

    @action setupdateLoading(value) {
        this.updateLoading = value;
    }

    @action setname(value) {
        this.template.name = value;
    }

    @action setisSelected(value) {
        this.template.isSelected = value;
    }

    @action settheme(value) {
        this.template.templateSetting.theme = value;
    }

    @action setmenucolumn(value) {
        this.template.templateSetting.menu.column = value;
    }

    @action setmenumarginTop(value) {
        this.template.templateSetting.menu.marginTop = value;
    }

    @action setmenumarginBottom(value) {
        this.template.templateSetting.menu.marginBottom = value;
    }

    // Background

    @action setheaderBackgroundColor(value) {
        this.template.templateSetting.header.backgroundColor = value;
    }

    @action setbuttonItemBackgroundColor(value) {
        this.template.templateSetting.buttonItem.backgroundColor = value;
    }

    @action setbuttonItemSelectedBackgroundColor(value) {
        this.template.templateSetting.buttonItemSelected.backgroundColor = value;
    }

    @action setbuttonFooterBackgroundColor(value) {
        this.template.templateSetting.buttonFooter.backgroundColor = value;
    }

    @action setfooterBackgroundColor(value) {
        this.template.templateSetting.footer.backgroundColor = value;
    }

    // Border Color

    @action setbuttonItemBorderColor(value) {
        this.template.templateSetting.buttonItem.borderColor = value;
    }

    @action setbuttonItemSelectedBorderColor(value) {
        this.template.templateSetting.buttonItemSelected.borderColor = value;
    }

    // Home Header

    @action sethomeHeaderFontFamily(value) {
        this.template.templateSetting.homeHeader.fontFamily = value;
    }

    @action sethomeHeaderFontColor(value) {
        this.template.templateSetting.homeHeader.color = value;
    }

    @action sethomeHeaderFontSize(value) {
        this.template.templateSetting.homeHeader.fontSize = value;
    }

    // Home Info

    @action sethomeInfoFontFamily(value) {
        this.template.templateSetting.homeInfo.fontFamily = value;
    }

    @action sethomeInfoFontColor(value) {
        this.template.templateSetting.homeInfo.color = value;
    }

    @action sethomeInfoFontSize(value) {
        this.template.templateSetting.homeInfo.fontSize = value;
    }

    // Menu

    @action setmenuFontFamily(value) {
        this.template.templateSetting.menu.fontFamily = value;
    }

    @action setmenuFontColor(value) {
        this.template.templateSetting.menu.color = value;
    }

    @action setmenuFontSize(value) {
        this.template.templateSetting.menu.fontSize = value;
    }

    // Header

    @action setheaderFontFamily(value) {
        this.template.templateSetting.header.fontFamily = value;
    }

    @action setheaderFontColor(value) {
        this.template.templateSetting.header.color = value;
    }

    @action setheaderFontSize(value) {
        this.template.templateSetting.header.fontSize = value;
    }

    // Button Item

    @action setbuttonItemFontFamily(value) {
        this.template.templateSetting.buttonItem.fontFamily = value;
    }

    @action setbuttonItemFontColor(value) {
        this.template.templateSetting.buttonItem.color = value;
    }

    @action setbuttonItemFontSize(value) {
        this.template.templateSetting.buttonItem.fontSize = value;
    }

    // Button Item Selected

    @action setbuttonItemSelectedFontFamily(value) {
        this.template.templateSetting.buttonItemSelected.fontFamily = value;
    }

    @action setbuttonItemSelectedFontColor(value) {
        this.template.templateSetting.buttonItemSelected.color = value;
    }

    @action setbuttonItemSelectedFontSize(value) {
        this.template.templateSetting.buttonItemSelected.fontSize = value;
    }

    // Button Footer

    @action setbuttonFooterFontFamily(value) {
        this.template.templateSetting.buttonFooter.fontFamily = value;
    }

    @action setbuttonFooterFontColor(value) {
        this.template.templateSetting.buttonFooter.color = value;
    }

    @action setbuttonFooterFontSize(value) {
        this.template.templateSetting.buttonFooter.fontSize = value;
    }

    // Footer

    @action setfooterFontFamily(value) {
        this.template.templateSetting.footer.fontFamily = value;
    }

    @action setfooterFontColor(value) {
        this.template.templateSetting.footer.color = value;
    }

    @action setfooterFontSize(value) {
        this.template.templateSetting.footer.fontSize = value;
    }

    // Tab

    @action settabFontFamily(value) {
        this.template.templateSetting.tab.fontFamily = value;
    }

    @action settabFontColor(value) {
        this.template.templateSetting.tab.color = value;
    }

    @action settabFontSize(value) {
        this.template.templateSetting.tab.fontSize = value;
    }

    // Tab Selected

    @action settabSelectedFontFamily(value) {
        this.template.templateSetting.tabSelected.fontFamily = value;
    }

    @action settabSelectedFontColor(value) {
        this.template.templateSetting.tabSelected.color = value;
    }

    @action settabSelectedFontSize(value) {
        this.template.templateSetting.tabSelected.fontSize = value;
    }

    // Label

    @action setlabelFontFamily(value) {
        this.template.templateSetting.label.fontFamily = value;
    }

    @action setlabelFontColor(value) {
        this.template.templateSetting.label.color = value;
    }

    @action setlabelFontSize(value) {
        this.template.templateSetting.label.fontSize = value;
    }

    // Text

    @action settextFontFamily(value) {
        this.template.templateSetting.text.fontFamily = value;
    }

    @action settextFontColor(value) {
        this.template.templateSetting.text.color = value;
    }

    @action settextFontSize(value) {
        this.template.templateSetting.text.fontSize = value;
    }

    // Reset

    @action resetData() {
        this.template = null;
        this.templates = [];
    }
}

export default new templateStore()
